import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import usePage from "../../hooks/usePage";
import LotteryFlow from "./LotteryFlow/LotteryFlow";
import Equipment from "./Equipment/Equipment";
import { updateStatus } from "../../actions/userActions";

// 隨機抽取
const randomLottery = (ogArray) => {
  const array = [...ogArray];
  const result = [];

  // 被抽抽的數量不夠，直接返回整個陣列
  if (array.length <= 3) {
    return array;
  }

  while (result.length < 3) {
    const randomIndex = Math.floor(Math.random() * array.length);
    result.push(array[randomIndex]);
    array.splice(randomIndex, 1);
  }

  return result;
};

export default function Lottery() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  usePage({ headerShow: false });

  const statusData = useSelector((state) => state.user.statusData);
  const { user_no, bear_set, user_progress } = statusData;
  const courseInfo = useSelector((state) => state.user.courseInfo);
  const bearSetInfo = useSelector((state) => state.user.bearSetInfo);
  const userName = useSelector((state) => state.user.userName);

  const [start, setStart] = useState(true);
  const [newUnlockCourse, setNewUnlockCourse] = useState(null);
  const [showCourseData, setShowCourseData] = useState(null);
  const [putStatus, setPutStatus] = useState(false);
  // 判斷如果沒有新解鎖的課程，踢回首頁
  useEffect(() => {
    if (!start || !user_progress) {
      return;
    }

    const courseData = user_progress.find((item) => item.progress === 1);
    if (!courseData) {
      navigate("/");
    } else {
      setNewUnlockCourse(courseData);
      setStart(false);
    }
  }, [start]);

  // 取得新解鎖的課程資訊
  useEffect(() => {
    if (!newUnlockCourse || !bearSetInfo) {
      return;
    }

    // 取得課程名稱
    const couresData = courseInfo.find(
      (item) => item.id === newUnlockCourse.id,
    );
    // 取的課程相對應的裝備資訊
    const equipmentInfo = {
      ...bearSetInfo.find(
        (item) => item.categoryId === newUnlockCourse.bearSetId,
      ),
    };

    let lotteryList = [];
    // 背景
    if (newUnlockCourse.bearSetId === 7) {
      let backgroundId;
      switch (newUnlockCourse.id) {
        case 3:
          backgroundId = 1;
          break;
        case 5:
          backgroundId = 2;
          break;
        case 10:
          backgroundId = 3;
          break;
        case 11:
          backgroundId = 4;
          break;
        default:
          break;
      }
      lotteryList.push(
        equipmentInfo.equipment.find((item) => item.id === backgroundId),
      );
    } else {
      // 取得該裝備已擁有的項目
      const ownedEquipment = bear_set.find(
        (item) => item.categoryId === equipmentInfo.categoryId,
      ).equipment;
      // 將已抽過的裝備排除
      equipmentInfo.equipment = equipmentInfo.equipment.filter(
        (item) => !ownedEquipment.some((own) => own.id === item.id),
      );
      lotteryList = randomLottery(equipmentInfo.equipment);
      lotteryList = lotteryList.sort((a, b) => a.id - b.id);
    }
    setShowCourseData({
      ...newUnlockCourse,
      name: couresData.name,
      equipment: {
        title: equipmentInfo.title,
        equipment: lotteryList,
      },
    });
  }, [newUnlockCourse, bearSetInfo]);

  const clickUnlockHandler = () => {
    setPutStatus(true);
  };

  // 更新
  useEffect(() => {
    if (putStatus) {
      const newUserProgress = JSON.parse(JSON.stringify(user_progress)).map(
        (item) => {
          if (item.id === showCourseData.id) {
            item.progress = 2;
          }
          return item;
        },
      );

      const newBearSet = JSON.parse(JSON.stringify(bear_set)).map((item) => {
        if (item.categoryId === showCourseData.bearSetId) {
          item.isLock = false;
          showCourseData.equipment.equipment.forEach((equipmentItem) => {
            item.equipment.push({
              id: equipmentItem.id,
              isWear: false,
              isNew: true,
            });
          });
          item.equipment = item.equipment.sort((a, b) => a.id - b.id);
        }
        return item;
      });

      dispatch(
        updateStatus({
          user_no,
          user_progress: newUserProgress,
          bear_set: newBearSet,
        }),
      );
      setPutStatus(false);
    }
  }, [putStatus]);

  const clickConfirmHandler = () => {
    const hasNext = user_progress.find((item) => item.progress === 1);
    if (!hasNext) {
      navigate("/myBear");
    } else {
      setShowCourseData(null);
      setStart(true);
    }
  };

  return (
    <>
      {showCourseData ? (
        <LotteryFlow
          userName={userName}
          completionDate={showCourseData.completionDate}
          courseName={showCourseData.name[i18n.language]}
          equipmentName={showCourseData.equipment.title[i18n.language]}
          clickUnlockHandler={clickUnlockHandler}
          clickConfirmHandler={clickConfirmHandler}
        >
          {showCourseData.equipment.equipment.map((item) => (
            <Equipment
              img={item.imageInfo[0].listSrc || item.imageInfo[0].canvasBg}
              name={item.name[i18n.language]}
              styleCls={`${showCourseData.bearSetId === 7 ? "isBg" : ""}`}
              key={item.id}
            ></Equipment>
          ))}
        </LotteryFlow>
      ) : (
        ""
      )}
    </>
  );
}
